/**
 * Labstep
 *
 * @module core/Pre
 * @desc Custom pre tag component
 * White space is set to pre
 */

import type React from 'react';
import styles from './styles.module.scss';
import type { IPreProps } from './types';

export const Pre: React.FC<IPreProps> = ({ children }) => (
  <div className={styles.container}>{children}</div>
);
